import { render, staticRenderFns } from "./vehicleUpdatingToday.vue?vue&type=template&id=1420ab82"
import script from "./vehicleUpdatingToday.vue?vue&type=script&lang=js"
export * from "./vehicleUpdatingToday.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports